import dynamic from "next/dynamic";
import Head from "next/head";

const Sitemap = dynamic(() => import("../js/Components/Sitemap/Sitemap"))

const route = ({ data }) => {
    return (
        <>
            <Head>
                <title>{`Sitemap - ${process.env.brand.brand_name}`}</title>
            </Head>
            <Sitemap {...data}/>
        </>
    );
};

export async function getServerSideProps({ query, res }) {
    
    res.setHeader(
        'Cache-Control',
        'public, s-maxage=43200, stale-while-revalidate=59'
      );

    const req = await fetch(
        `${process.env.BASE_API_URL}sitemap`
    ); //find the category data from the url
    const data = await req.json();

    if(data.exception) {
        return {notFound: true}
    }
    
    return {
        props: {
            //pass props into route
            data,
        },
    };
}

export default route;
